export function getRegion(hostname: string, domain: string) {
  const allFsStands = new Array(20).map((_, index) => `fs${index}`);
  const defenetlyNotARegion = [
    ...allFsStands,
    'ux',
    'aem',
    'localhost',
    'leroymerlin',
    'lemanapro',
    'mf',
    'publish',
    'author',
    'yandex',
    'arulm',
    'triffle',
    'dispatcher',
  ];

  if (
    ['adeo.com', 'lemanapro.ru', 'leroymerlin.ru', 'localhost', 'lmru.tech'].some(
      matchingDomain => domain === matchingDomain
    )
  ) {
    const [maybeRegion] = hostname.split('.');

    if (!defenetlyNotARegion.some(prefix => maybeRegion.startsWith(prefix))) {
      return maybeRegion;
    }
  }

  return 'moscow';
}
